'use strict';

const isPlainObject = require('../rlink-type-utils/isPlainObject');

module.exports = function objectOf (valueChecker, ...args) {
  const [isRequired = false, ...restArgs] = args;
  const checker = (obj, key, cname, location, fullName) => {
    const value = obj[key];

    if (!isRequired && (typeof value === 'undefined' || value === null)) {
      return null;
    }

    if (!isPlainObject(value)) {
      return new TypeError(`Value at ${fullName} is not plain object.`);
    }

    for (let objKey of Object.keys(value)) {
      const check = valueChecker(value, objKey, cname, location, `${fullName}.${objKey}`);

      if (check) {
        return check;
      }
    }

    return null;
  };

  checker.getCheckerForKey = () => valueChecker;
  checker.makeNew = () => ({});
  checker.checkerName = 'objectOf';

  if (isRequired) {
    checker.isRequired = checker;
  } else {
    checker.isRequired = objectOf(valueChecker, true);
  }

  if (restArgs.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }

  if (typeof valueChecker !== 'function') {
    throw new Error(`Invalid checker for ${checker.checkerName}: ${valueChecker}`);
  }

  if (!valueChecker.checkerName) {
    throw new Error(`Non-rlink-shape checker for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
  }

  return checker;
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/objectOf.js